import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const footerLinks = [
    {
      title: '热门分类',
      links: categories.filter(c => c.slug !== 'all').slice(0, 4).map(c => ({
        label: c.name,
        href: `/category/${c.slug}`,
      })),
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', href: '/about' },
        { label: '平台数据', href: '/about' },
        { label: '商务合作', href: '/about' },
        { label: '联系方式', href: '/about' },
      ],
    },
    {
      title: '帮助中心',
      links: [
        { label: '常见问题', href: '/about' },
        { label: '阅读指南', href: '/about' },
        { label: '版权声明', href: '/about' },
        { label: '用户协议', href: '/about' },
      ],
    },
    {
      title: '关注我们',
      links: [
        { label: '微博', href: '#' },
        { label: '微信公众号', href: '#' },
        { label: '小红书', href: '#' },
        { label: '抖音', href: '#' },
      ],
    },
  ];

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4 pb-3 border-b border-secondary-700/50">
                {col.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <div className="flex items-baseline gap-1">
              <span className="text-3xl font-black text-background-50 font-heading">韩漫画网</span>
            </div>
            <p className="text-xs text-background-400 mt-2">韩漫在线阅读 - 原汁原味的韩国漫画体验</p>
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <span className="text-xs text-background-400">© 2026 韩漫画网 版权所有</span>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-secondary-700 transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-links-line text-sm text-background-300"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-secondary-700 transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-sm text-background-300"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-secondary-700 transition-colors" aria-label="B站" rel="nofollow">
                <i className="ri-movie-line text-sm text-background-300"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-secondary-700 transition-colors" aria-label="邮箱" rel="nofollow">
                <i className="ri-mail-line text-sm text-background-300"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}